export const BlueColor = '#3794ff';
export const DarkBlueColor = '#1976d2';